import { isValidCuij } from "@tribunalea/shared";

const NUMERIC_IDENTIFIER_PATTERN = /^\d[\d/-]*$/;

export function prepareExpedienteSearchQuery(value) {
  const query = String(value || "").trim();
  if (!query) return { query, kind: "invalid" };
  if (isValidCuij(query)) return { query, kind: "cuij" };
  if (NUMERIC_IDENTIFIER_PATTERN.test(query)) {
    return { query, kind: "lookup" };
  }
  return {
    query,
    kind: query.length >= 3 ? "lookup" : "invalid",
  };
}

export function expedienteSearchQueryFromUrl(search = "") {
  return new URLSearchParams(search).get("q") || "";
}

export function expedienteSearchPageFromUrl(search = "") {
  const page = Number(new URLSearchParams(search).get("page"));
  return Number.isInteger(page) && page > 0 ? page : 1;
}

export function buildExpedienteSearchUrl(
  query,
  { page = 1, searchPath = "/buscar-expedientes" } = {},
) {
  const params = new URLSearchParams({ q: String(query).trim() });
  if (page > 1) params.set("page", String(page));
  return `${searchPath}?${params.toString()}`;
}

export function expedientePaginationItems(page, totalPages) {
  const total = Math.max(1, Number(totalPages) || 1);
  const current = Math.min(total, Math.max(1, Number(page) || 1));
  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }

  const items = [1];
  if (current > 3) items.push("start-ellipsis");
  for (
    let value = Math.max(2, current - 1);
    value <= Math.min(total - 1, current + 1);
    value += 1
  ) {
    items.push(value);
  }
  if (current < total - 2) items.push("end-ellipsis");
  items.push(total);
  return items;
}
